import { useState, useLayoutEffect } from 'react';

/**
 * Misst die tatsächlich gerenderte Spaltenzahl eines CSS-Grids.
 * Liest `grid-template-columns` (von `auto-fill minmax(...)` aufgelöst zu Pixel-Tracks)
 * und zählt die Tracks. Aktualisiert live via ResizeObserver.
 *
 * @param {React.RefObject<HTMLElement>} ref — Ref auf das Grid-Element
 * @returns {number} aktuelle Spaltenzahl (0 bis erste Messung)
 */
export default function useGridColumns(ref) {
  const [columns, setColumns] = useState(0);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const measure = () => {
      const tpl = getComputedStyle(el).gridTemplateColumns;
      const count = tpl && tpl !== 'none' ? tpl.split(' ').filter(Boolean).length : 0;
      setColumns(count);
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref]);
  return columns;
}
